<template>
  <q-item-label
    class="text-bold text-red-7"
  >
    SMS notifications cost {{ formattedPrice }} per {{ smsPricing.per_characters || 160 }}-characters.
    <br />Total usage charges can be found on your subscription invoice.
  </q-item-label>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SmsChargeWarning',
  computed: {
    ...mapGetters(['getSystemSetting']),
    smsPricing () {
      return this.getSystemSetting('sms_pricing') || {
        per_message_cost: 0.10,
        currency: 'AUD',
        per_characters: 160
      }
    },
    formattedPrice () {
      const cost = this.smsPricing.per_message_cost || 0.10
      const currency = this.smsPricing.currency || 'AUD'

      // Format based on currency
      if (currency === 'USD') {
        return `$${cost.toFixed(2)}`
      }
      else if (currency === 'AUD') {
        return `$${cost.toFixed(2)}`
      }
      else {
        return `${cost.toFixed(2)} ${currency}`
      }
    }
  },
  async mounted () {
    try {
      await this.$store.dispatch('fetchSmsPricing')
    }
    catch (error) {
      console.error('Failed to fetch SMS pricing:', error)
    }
  }
}
</script>
